export enum MessageType {
  message,
  box,
  order,
  deliveryStatus,
}
